import {
  AgxButton,
  AgxRow,
  AgxColumn,
  AgxTextInput,
  AgxBodyText,
  Images,
  AgxDivider,
} from '@urbanx/agx-ui-components';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { formatCurrency } from 'utils/formatNumber';
import RPDataDisclaimer from 'components/common/RPDataDisclaimer';
import { ComparativeAddress } from '../ComparativeMarketAnalysis/types';
import './CMASelectedProperties.scss';

dayjs.extend(relativeTime);

interface CMASelectedPropertiesProps {
  selectedProperties: ComparativeAddress[];
  onEditSelectedProperties: () => void;
}

export const CMASelectedProperties = ({
  selectedProperties,
  onEditSelectedProperties,
}: CMASelectedPropertiesProps) => {
  return (
    <>
      <AgxColumn fill extraClasses="selectedProperties">
        {selectedProperties.map((property, i) => {
          const {
            propertyAddress: address,
            soldPrice: price,
            distanceInKilometers: distanceFromProperty,
            propertyDetails: propertyDetails,
            settlementDate: settlementDate,
          } = property;

          const timeAgo =
            settlementDate !== null ? dayjs(settlementDate).fromNow(true) : '';

          return (
            <div key={`address${i}+input`} className="searchNowProperty">
              <AgxTextInput
                defaultValue={address}
                readonly
                id={`address${i}`}
                stretch
                extraClasses="addressInput"
                label={`Comparable ${i + 1}`}
                optionalLabelText={`${distanceFromProperty}km away`}
              />
              <AgxTextInput
                defaultValue={formatCurrency(price, 0)}
                readonly
                noHeader
                id={`address${i}-input`}
                stretch
                extraClasses="priceInput"
              />
              <AgxRow mediumGap centered extraClasses="details">
                <AgxRow smallGap centered>
                  <Images.Bed />
                  <AgxBodyText small>
                    {propertyDetails?.numberOfBeds}
                  </AgxBodyText>
                </AgxRow>
                <AgxRow smallGap centered>
                  <Images.Bath />
                  <AgxBodyText small>
                    {propertyDetails?.numberOfBathrooms}
                  </AgxBodyText>
                </AgxRow>
                <AgxRow smallGap centered>
                  <Images.Car />
                  <AgxBodyText small>
                    {propertyDetails?.numberOfCarSpaces}
                  </AgxBodyText>
                </AgxRow>
                <AgxRow smallGap centered>
                  <Images.Area />
                  <AgxBodyText small>
                    {propertyDetails?.landAreaDetails?.totalLandArea}m²
                  </AgxBodyText>
                </AgxRow>
                <AgxRow smallGap centered>
                  <AgxBodyText small>{timeAgo}</AgxBodyText>
                </AgxRow>
              </AgxRow>
            </div>
          );
        })}
        <AgxButton
          id="editComparables"
          text="Edit Comparables"
          primary
          medium
          onClick={() => {
            onEditSelectedProperties();
          }}
        />
        <AgxDivider />
        <RPDataDisclaimer />
      </AgxColumn>
    </>
  );
};
